import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { history } from '../../router/BrowserRouter';
import { State } from './types';
import {
    signInThunk,
    logOutThunk,
    getUserInfoThunk,
} from './thunks';

const isLoggedIn = localStorage.getItem('auth_status') === 'Authenticated' ? true : false;

const initialState: State = {
    isLoggedIn,
    userId: null,
    fetchStatus: 'Idle',
    loggingOut: false,
    logOutModal: false,
    accessToProtectedRoutes: !isLoggedIn,
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setIsLoggedIn: (state, action: PayloadAction<boolean>) => {
            state.isLoggedIn = action.payload;
        },
        setAccessToProtectedRoutes: (state, action: PayloadAction<boolean>) => {
            state.accessToProtectedRoutes = action.payload;
        },
        setLogOutModal: (state, action: PayloadAction<boolean>) => {
            state.logOutModal = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(signInThunk.pending, (state) => {
                state.fetchStatus = 'Pending';
            })
            .addCase(signInThunk.fulfilled, (state) => {
                state.fetchStatus = 'Idle';
            })
            .addCase(signInThunk.rejected, (state) => {
                state.fetchStatus = 'Rejected';
            })
            .addCase(getUserInfoThunk.pending, (state) => {
                state.fetchStatus = 'Pending';
            })
            .addCase(getUserInfoThunk.fulfilled, (state, action) => {
                state.userId = action.payload;
                state.isLoggedIn = true;
                state.fetchStatus = 'Idle';
            })
            .addCase(getUserInfoThunk.rejected, (state) => {
                state.userId = null;
                state.isLoggedIn = false;
                localStorage.clear();
                state.fetchStatus = 'Rejected';
            })
            .addCase(logOutThunk.pending, (state) => {
                state.loggingOut = true;
            })
            .addCase(logOutThunk.rejected, (state) => {
                state.loggingOut = false;
            })
            .addCase(logOutThunk.fulfilled, (state) => {
                localStorage.clear();
                history.push('/');
                state.loggingOut = false;
                state.isLoggedIn = false;
                state.logOutModal = false;
                state.accessToProtectedRoutes = true;
                window.location.reload();
            })
    }
})

export const {
    setIsLoggedIn,
    setLogOutModal,
    setAccessToProtectedRoutes,
} = authSlice.actions;